import { trimMoney } from 'utils/strings';

import Base from 'app/views/base';

import DropdownSelection from 'app/models/dropdown_selection';

import PopupBaseView from 'app/components/popup_base';
import LoaderView from 'app/views/loader_view';
import SelectorView from 'app/views/selector_view';

import tmpl from './template';
import paymentMethodSelectorTemplate from './payment_method_selector';
import oneTimeChargeTemplate from './one_time_charge_popup';

export const PaymentMethodSelectorView = SelectorView.extend({
  compiledTemplate: paymentMethodSelectorTemplate,

  initialize(options) {
    SelectorView.prototype.initialize.apply(this, [options]);
    this.paymentMethods = options.paymentMethods;
  },

  context() {
    const currentPaymentMethod = this.paymentMethods[this.model.getVal()]();
    return {
      label: this.model.label,
      choices: this.model.choices,
      currentChoice: this.model.get('currentChoice'),
      chargeableType: currentPaymentMethod ? currentPaymentMethod.get('object') : '',
    };
  },
});

export const OneTimeChargePopupView = PopupBaseView.extend({
  compiledTemplate: oneTimeChargeTemplate,

  events: {
    ...PopupBaseView.prototype.events,
    'click .submit_charge': 'submitCharge',
  },

  initialize({ user, paymentMethods }) {
    this.user = user;
    this.paymentMethods = paymentMethods;
    this.paymentMethodSelection = new DropdownSelection({
      choices: [
        this.paymentMethods.primary() ? { option: 'primary', readable: 'Primary Account' } : null,
        this.paymentMethods.secondary() ? { option: 'secondary', readable: 'Secondary Account' } : null,
      ].filter(Boolean),
      label: 'One-time charge from',
    });
    this.chargeAmountsSelection = new DropdownSelection({
      choices: [
        { option: '2000', readable: '$20' },
        { option: '5000', readable: '$50' },
        { option: '10000', readable: '$100' },
        { option: '50000', readable: '$500' },
        { option: '100000', readable: '$1,000' },
        { option: '250000', readable: '$2,500' },
        { option: '500000', readable: '$5,000' },
        { option: '1000000', readable: '$10,000' },
        { option: '1500000', readable: '$15,000' },
        { option: '2000000', readable: '$20,000' },
      ],
      label: 'Amount',
    });

    this.addSubview('paymentMethodSelector', '#payment_method_selector', new PaymentMethodSelectorView({
      model: this.paymentMethodSelection, paymentMethods: this.paymentMethods,
    }));
    this.addSubview('chargeAmountSelector', '#charge_amount_selector', new SelectorView({
      model: this.chargeAmountsSelection, btnClasses: 'btn-clear btn-block',
    }));
  },

  submitCharge() {
    const paymentMethod = this.paymentMethods[this.paymentMethodSelection.getVal()]();
    paymentMethod.charge(this.chargeAmountsSelection.getVal(), this.user);
  },
});

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ user, paymentMethods }) {
    this.user = user;
    this.paymentMethods = paymentMethods;

    this.listenTo(this.user, 'change', this.render);
    this.listenTo(this.paymentMethods, 'change sync error', this.render);

    this.addSubview('balanceLoader', '#balance_loader', new LoaderView({ model: this.paymentMethods, cssClass: 'my-4' }));
  },

  beforeRender() {
    if (this.paymentMethods.firstFetchSuccess && this.paymentMethods.hasAPaymentMethod()) {
      this.addSubview('oneTimeCharge', '#one_time_charge', new OneTimeChargePopupView({
        user: this.user,
        paymentMethods: this.paymentMethods,
      }));
    } else {
      this.removeSubview('oneTimeCharge');
    }
  },

  context() {
    return {
      balance: trimMoney(this.user.get('balance'), 'USD'),
      firstFetchSuccess: this.paymentMethods.firstFetchSuccess && this.user.firstFetchSuccess,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/account_balance/index.js